<template>
  <div id="simulacao">
    <v-card flat class="pa-0" max-width="1700">
      <v-tabs v-model="step" :key="steppers.length" :slider-color="stepAtual.completed ? 'success' : 'primary'" vertical heigth="90px">
        <div class="d-flex align-center justify-space-between">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn class="mr-lg-2" color="primary" @click="voltar" v-on="on" small icon><v-icon medium>ph-caret-left</v-icon></v-btn>
            </template>
            <span>Voltar para a lista de Simulações</span>
          </v-tooltip>

          <span class="text-subtitle-2 text-lg-h5">Simulação da Proposta</span>

          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn class="ml-lg-2" @click="limpar" v-on="on" small icon data-cy-action="bound deletar"><v-icon medium>ph-trash</v-icon></v-btn>
            </template>
            <span>Limpar Simulação</span>
          </v-tooltip>
        </div>
        <v-tab :key="i" v-for="(item, i) in steppers" :disabled="item.showId > step" height="200px" class="elevation-2 my-2 mx-1">

          <v-row class="text-left" width="100%">
            <v-col class="py-4 px-0 text-caption text-lg-subtitle-1 d-flex align-center justify-space-between" cols="12">
              <span :class="item.completed ? 'success--text' : ''">{{ item.text }}</span>
              <v-icon :color="item.completed ? 'success' : ''" class="ml-2">{{ item.icon }}</v-icon>
            </v-col>
          </v-row>
        </v-tab>

        <v-tabs-items v-model="step" touchless>
          <v-tab-item eager v-for="(item, i) in steppers" v-show="item.showId === step" :key="i">
          <core-form ref="form" :submit="submit" v-show="item.showId === step">
            <v-card class="px-0 ma-2" tile>
              <v-card-text :style="height" class="px-0">
                <component v-bind:is="item.component"
                           v-bind="item.attrs"
                           v-model="model"
                           :isPF="isPF"
                           @close="close"
                           ref="itemStep"
                           @nextStep="nextStep" />
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions class="px-3">
                <div class="flex-grow-1"></div>
                <v-btn color="white" @click="backStep" v-if="step !== 0">voltar</v-btn>
                <v-btn v-if="step === 4" v-show="!showSubmit" type="submit" color="primary" data-cy="finalizar">
                  Finalizar
                </v-btn>
                <v-btn v-else v-show="!showSubmit" type="submit" color="primary">
                  Continuar
                </v-btn>
              </v-card-actions>

            </v-card>
          </core-form>
        </v-tab-item>
        </v-tabs-items>
      </v-tabs>

    </v-card>
  </div>
</template>

<style>
  #simulacao .v-tabs--vertical > .v-tabs-bar .v-tab {
    height: 80px;
  }
</style>

<script>
import SimulacaoEditDadosPessoais from './SimulacaoEditDadosPessoais';
import SimulacaoEditOperacao from './SimulacaoEditOperacao';
import SimulacaoEditCredito from './SimulacaoEditCredito';
import SimulacaoEditGarantia from './SimulacaoEditGarantia';
import SimulacaoResumo from './SimulacaoResumo';

export default {
  data () {
    return {
      height: '100%',
      show: false,
      model: {
        TipoTacCorban: 'R$',
        GarantiaSimulacao: []
      },
      step: 0,
      buttonDisabled: true,
      TipoTacCorban: 'R$',
    };
  },
  computed: {
    steppers () {
      let list = [
        { id: 0, component: SimulacaoEditDadosPessoais, text: 'Dados Pessoais', icon: 'ph-user-list' },
        { id: 1, component: SimulacaoEditOperacao, text: 'Características da Operação', icon: 'ph-gear' },
        { id: 2, component: SimulacaoEditCredito, text: 'Dados do Crédito', icon: 'ph-coins' },
        { id: 3, component: SimulacaoEditGarantia, text: 'Garantias', icon: 'ph-shield-check', hide: !this.$api.Estruturadas.GarantiaVeiculo.includes(this.model.TipoContratoSigla) },
        { id: 4, component: SimulacaoResumo, text: 'Resumo da Simulação', icon: 'ph-clipboard-text' }
      ]
      list = list.filter(p => !p.hide)
      list.forEach((p, i) => {
        p.showId = i
        p.completed = i < this.step
      })
      return list
    },
    stepAtual () {
      return this.steppers.find((p) => p.showId === this.step);
    },
    stepModel: {
      get () {
        return this.step + 1;
      }
    },
    showSubmit: function () {
      return this.stepModel === this.steppersLength;
    },
    isPF () {
      return this.$api.UI.Format.SomenteAlfanumerico(this.model.DocumentoFederal).length === 11
    },
  },
  methods: {
    submit () {
      const th = this
      th.$refs.form[th.stepAtual.showId].validate(function () {
        if (th.$refs.itemStep[th.stepAtual.showId].submit) {
          th.$refs.itemStep[th.stepAtual.showId].submit(() => {
            th.nextStep()
          })
        } else {
          th.nextStep()
        }
      });
    },
    nextStep () {
      this.step += 1
      if (this.$refs.itemStep[this.stepAtual.showId].load) {
        this.$refs.itemStep[this.stepAtual.showId].load()
        this.scrollTop(0, 0)
      }
    },
    backStep () {
      this.step--
    },
    voltar () {
      this.$router.push('/simulacao')
    },
    limpar () {
      const th = this

      th.$api.UI.Confirmacao('alerta', 'Tem certeza que deseja descartar os dados desta simulação?', function () {
        th.close('novo')
      })
    },

    close (acao) {
      const th = this
      th.$set(th, 'model', {})
      th.step = 0
      if (acao === 'lista') {
        th.$router.push('/simulacao')
      } else if (acao === 'novo') {
        th.$router.push('/simulacao-edit')
        th.$refs.form.forEach(p => p.reset())
      }
    },

    avisoEmissaoVencida () {
      this.$set(this.model, 'DtPrimeiroVencto', null)
      this.$set(this.model, 'DtEmissao', null)
      this.$set(this.model, 'DtDesembolso', null)
      this.$api.UI.Mensagem('alerta', 'Data de emissão vencida, necessário selecionar uma nova data', function () {}, 'Aviso')
    }
  },
  mounted () {
    const th = this
    const codigoSimulacao = this.$route.query.codigoSimulacao
    const dataAtual = new Date()

    if (codigoSimulacao) {
      th.$api.Simulacao.Get(codigoSimulacao).then(response => {
        if (th.$api.UI.PostLoadData(response, true)) {
          th.$set(th, 'model', JSON.parse(response.modelJson))
          th.$set(th.model, 'Codigo', response.codigo)
          th.$set(th.model, 'CodigoEmpresa', response.codigoEmpresa)
          th.$set(th.model, 'CodigoUsuario', response.codigoUsuario)
          th.$set(th.model, 'Descricao', response.descricao)
          th.$set(th.model, 'DtExpiracao', response.dtExpiracao.toString().split('T')[0])
          th.$set(th.model, 'Id', response.id)
          th.$set(th.model, 'IsValid', response.isValid)
          th.$set(th.model, 'Nome', response.nome)
          th.$set(th.model, 'TipoRegistro', response.tiporegistro)
          th.$set(th.model, 'metodoEnvio', null)
          th.$set(th.model, 'email', null)
          th.$set(th.model, 'opcaoSelecionada', null)

          th.$nextTick(() => {
            if (this.$api.UI.Date.DaysBetween(dataAtual, th.model.DtEmissao) < 0) {
              th.nextStep()
              th.avisoEmissaoVencida()
            } else {
              th.nextStep()
              th.nextStep()
            }
            th.$nextTick(() => {
              th.nextStep()
            })
          })
        }
      })
    }

    const el = document.querySelector('.v-main__wrap')
    const elMin = document.querySelector('#simulacao .v-tabs-bar .v-tabs-bar__content')
    this.$set(th, 'height', `max-height: ${el.offsetHeight - 118}px;min-height: ${elMin.offsetHeight - 69}px;overflow: auto;`)
  }
};
</script>
